<template>
  <div class="component cards px-xs-sm-2">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="choose-area-of-interest">
            <p>Choose an area of interest</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="items">
            <div class="item" v-for="(item, index) in items">
              <a
                v-bind:href="item.href"
                v-bind:target="item.target[0]"
                class="card"
                v-on:mouseover="mouseover(index)"
              >
                <figure>
                  <img
                    class="img-fluid"
                    v-bind:class="[item.illustration.replace(/\.svg/g, '')]"
                    v-bind:src="`@/assets/images/${item.illustration}`"
                  />
                </figure>
                <div class="content">
                  <div class="mb-3 content-body">
                    <h5 v-html="item.title"></h5>
                    <p v-html="item.description"></p>
                  </div>

                  <div class="call-to-action">
                    <a
                      v-bind:href="item.href"
                      v-bind:target="item.target[0]"
                      class="btn"
                      v-bind:class="{
                        'cta-plain text-red icon right-arrow':
                          item.style === 'text',
                        'cta-pill filled-red icon right-arrow':
                          item.style === 'pill',
                      }"
                      >{{ item.cta }}</a
                    >
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "area-of-interest",
  props: {
    cards: {
      type: Array,
    },
    animations: {
      type: Array,
    },
  },
  data() {
    return {
      active: false,
      items: [],
    };
  },
  methods: {
    mouseover(index) {
      for (let value of this.items) {
        value.play = false;
      }

      this.$nextTick(() => {
        this.items[index].play = true;
      });
    },
  },
  created() {
    this.items = Object.assign([], this.cards);

    this.animations.forEach((el, index) => {
      this.items[index].animation = el;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.cards {
  padding: 3rem 0;
  margin-bottom: -6rem;
  transform: translateY(-9rem);

  @media (min-width: 768px) {
    transform: translateY(-12rem);
    margin-bottom: 0;
  }

  .choose-area-of-interest {
    @extend %body-normal-bold;

    margin: 0 auto 0.5rem auto;
    max-width: 360px;
    text-align: center;

    @media (min-width: 1200px) {
      text-align: left;
      max-width: none;
    }

    p {
      position: relative;
      color: $cc-resmed-white;

      &:before {
        content: "";
        position: absolute;
        top: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 1.25rem;
        height: 3px;
        background-color: $cc-resmed-white;
      }

      @media (min-width: 1200px) {
        &:before {
          left: 0;
          transform: none;
        }
      }
    }
  }

  .items {
    margin: 0 -0.625rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      padding: 0.625rem;

      @media (min-width: 768px) {
        width: calc(100% / 2);
      }

      @media (min-width: 992px) {
        max-width: 322px;
      }

      @media (min-width: 1200px) {
        width: calc(100% / 4);
      }

      .card {
        display: flex;
        flex-direction: column;
        color: inherit;

        background-color: $cc-resmed-white;
        box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;
        padding: 2rem 1rem 2.5rem 1rem;

        max-width: 360px;
        transition: all 0.5s;
        cursor: pointer;
        height: 100%;

        &:hover {
          background-color: $cc-resmed-bg-grey-2;
        }

        @media (min-width: 768px) {
          max-width: none;
          min-height: 460px;
        }

        @media (min-width: 1200px) {
          min-height: 500px !important;
        }

        figure {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.625rem;

          .animation,
          .img-fluid {
            height: 224px;
            width: 100%;
            max-width: 224px;
          }

          .animation {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          svg {
            width: 224px !important;
            height: 224px !important;
          }

          @media (min-width: 768px) {
            .illustration-portable-oxygen {
              max-width: 190px;
            }
          }

          @media (min-width: 1200px) {
            .illustration-sleep-apnea {
              max-width: 220px;
            }

            .illustration-portable-oxygen {
              max-width: 180px;
            }

            .illustration-ventilation {
              max-width: 210px;
            }

            .illustration-healthcare-professionals {
              max-width: 194px;
            }
          }
        }

        .content {
          padding: 0 0.5rem;
          text-align: center;

          @media (min-width: 768px) {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
            text-align: left;

            padding: 0 0.25rem 0 0.75rem;

            .content-body {
              flex: 1 0 auto;
            }
          }

          h5 {
            margin-bottom: 0.75rem;
          }

          .call-to-action {
            align-self: flex-start;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.area-of-interest {
  .cards {
    h5 > span {
      display: block;
    }
  }
}
</style>